import React from "react";
import { useTranslation } from "react-i18next";
import { ApiInternal } from "src/api/api_internal";
import { FullDevice } from "src/api/generated/frontend_internal_v1";
import { ConfirmDialog } from "src/components/base/confirm-dialog";
import { notify } from "src/components/base/toast";

/**
 * The properties for {@link DeleteDeviceDialog}
 */
export type DeleteDeviceDialogProps = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDeletion: () => void;
    /** The device */
    device: FullDevice | undefined;
};

/**
 * A dialog to delete a device — kept as a thin wrapper so call-sites stay
 * unchanged while sharing the central {@link ConfirmDialog} primitive.
 */
export default function DeleteDeviceDialog(props: DeleteDeviceDialogProps) {
    const [t] = useTranslation("dialog-delete-device");

    if (!props.device) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.device) return;
                await ApiInternal.devices.deleteDevice(props.device.uuid);
                notify.success(t("toast.device-deleted-successfully"));
                props.onDeletion();
            }}
            title={t("heading.delete-device", { device: props.device.dnsname })}
            description={t("description.delete-device")}
            confirmLabel={t("button.delete-device")}
            confirmColor="red"
        />
    );
}
